// removed by extract-text-webpack-plugin
module.exports = {"attributesTable":"_2sAhT","row":"_1CcUF","baseAttribute":"_3GVDz","header":"_1T1tR","textLink":"_2XLor _3GVDz","text":"_1vrNt","chevron":"_1KCqi","tagCloud":"_1IEhS _3GVDz","tagCloudFilter":"_1_jQT","count":"_2aiTB"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/ProductAttributes/index.sass
// module id = 1498
// module chunks = 1